const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const fallbackImage = "";

const sizeToNumber = (size) => {
  const parsed = parseFloat(String(size || "").replace(/[^\d.]/g, ""));
  return Number.isFinite(parsed) ? parsed : 0;
};

export const productCatalog = [
  {
    slug: "epsom-salt",
    name: "Epsom Salt",
    category: "Cleansers",
    section: "Bath Salts",
    bestSeller: true,
    rating: 4.9,
    reviews: 221,
    description: "Mineral-rich bath salt blend to refresh body and elevate your self-care ritual.",
    ingredients: ["Epsom Salt", "Rose Petals", "Rose Powder", "Essence Oil"],
    howToUse:
      "Mix 1 tbsp of salt with your favorite carrier oil. Apply as a scrub on wet body in circular motions, then rinse.",
    images: [],
    variants: [
      { id: "rose-10g", label: "Rose", size: "10 g", price: 99, isTrial: true },
      { id: "rose-100g", label: "Rose", size: "100 g", price: 549, isTrial: false },
      { id: "gardenia-10g", label: "Gardenia", size: "10 g", price: 99, isTrial: true },
      { id: "gardenia-100g", label: "Gardenia", size: "100 g", price: 549, isTrial: false },
    ],
  },
  {
    slug: "blessed-sea-salt",
    name: "Blessed Sea Salt",
    category: "Cleansers",
    section: "Bath Salts",
    bestSeller: false,
    rating: 4.7,
    reviews: 112,
    description: "Sacred cleansing blend designed for home energy purification rituals.",
    ingredients: ["Sea Salt", "Coconut Oil", "Turmeric", "Bhimseni Camphor"],
    howToUse:
      "Place a small amount on a metal plate in a hidden corner of your home. Discard the salt after 7 days.",
    images: [],
    variants: [
      { id: "camphor-15g", label: "Camphor", size: "15 g", price: 99, isTrial: true },
      { id: "camphor-100g", label: "Camphor", size: "100 g", price: 549, isTrial: false },
    ],
  },
  {
    slug: "rose-oil",
    name: "Rose Oil",
    category: "Serums",
    section: "Body & Face Oils",
    bestSeller: true,
    rating: 4.8,
    reviews: 187,
    description: "Nourishing floral oil to soften skin and bring a naturally healthy glow.",
    ingredients: ["Olive Oil", "Rose Oil", "Calendula Nectar"],
    howToUse: "Apply desired amount to skin and massage well. Ideal for daily use.",
    images: [],
    variants: [
      { id: "rose-6ml", label: "Rose", size: "6 ml", price: 149, isTrial: true },
      { id: "rose-20ml", label: "Rose", size: "20 ml", price: 349, isTrial: false },
      { id: "rose-50ml", label: "Rose", size: "50 ml", price: 799, isTrial: false },
    ],
  },
  {
    slug: "saffron-rose-water",
    name: "Saffron Rose Water",
    category: "Serums",
    section: "Waters & Sprays",
    bestSeller: true,
    rating: 4.8,
    reviews: 203,
    description: "Hydrating floral mist that tones, refreshes, and comforts skin through the day.",
    ingredients: ["Dried Rose Petals", "Distilled Water", "Saffron Petals"],
    howToUse: "Use as toner after cleansing or spray throughout the day for hydration.",
    images: [],
    variants: [
      { id: "rose-10ml", label: "Rose", size: "10 ml", price: 99, isTrial: true },
      { id: "rose-50ml", label: "Rose", size: "50 ml", price: 349, isTrial: false },
    ],
  },
  {
    slug: "pedi-salt",
    name: "Pedi Salt",
    category: "Cleansers",
    section: "Bath Salts",
    bestSeller: false,
    rating: 4.7,
    reviews: 118,
    description: "Foot-soak salt blend to soften tired feet and support a clean, fresh feel.",
    ingredients: [
      "Epsom Salt",
      "Himalayan Salt",
      "Lemongrass Powder",
      "Neem Powder",
      "Bhimseni Camphor",
      "Baking Soda",
    ],
    howToUse: "Add 2 tbsp to lukewarm water, soak feet for 12-15 minutes, and dry with a clean towel.",
    images: [],
    variants: [
      { id: "lemon-10g", label: "Lemon", size: "10 g", price: 99, isTrial: true },
      { id: "lemon-100g", label: "Lemon", size: "100 g", price: 549, isTrial: false },
    ],
  },
  {
    slug: "rosemary-water",
    name: "Rosemary Water (Hair Spray)",
    category: "Serums",
    section: "Waters & Sprays",
    bestSeller: false,
    rating: 4.6,
    reviews: 94,
    description: "Lightweight herbal mist to refresh scalp and support healthy-looking hair roots.",
    ingredients: ["Rosemary Distillate", "Purified Water", "Herbal Extracts"],
    howToUse: "Spray directly on scalp and roots, then massage gently for absorption.",
    images: [],
    variants: [
      { id: "rosemary-10ml", label: "Rosemary", size: "10 ml", price: 99, isTrial: true },
      { id: "rosemary-50ml", label: "Rosemary", size: "50 ml", price: 349, isTrial: false },
    ],
  },
  {
    slug: "rosemary-oil",
    name: "Rosemary Oil",
    category: "Serums",
    section: "Body & Face Oils",
    bestSeller: true,
    rating: 4.8,
    reviews: 171,
    description: "Rich herbal oil blend designed to support scalp nourishment and stronger-looking hair.",
    ingredients: [
      "Almond Oil",
      "Castor Oil",
      "Rosemary",
      "Hemp Seeds",
      "Olive and Sesame Extracts",
      "Pomegranate and Flaxseed Extracts",
      "Dry Neem and Rose Petals",
    ],
    howToUse: "Apply to roots, massage for 10-15 minutes, and leave overnight for best results.",
    images: [],
    variants: [
      { id: "rosemary-6ml", label: "Rosemary", size: "6 ml", price: 99, isTrial: true },
      { id: "rosemary-50ml", label: "Rosemary", size: "50 ml", price: 649, isTrial: false },
    ],
  },
  {
    slug: "de-tan-glow-face-pack",
    name: "De-Tan Glow Face Pack",
    category: "Cleansers",
    section: "Face Packs & Ubtans",
    bestSeller: true,
    rating: 4.8,
    reviews: 214,
    description: "Powder mask blend crafted to visibly brighten and revive tired-looking skin.",
    ingredients: [
      "Sandalwood Powder",
      "Fuller's Earth",
      "Licorice Root",
      "Hibiscus",
      "Rose Petals",
      "Neem",
      "Curcuma Aromatica",
      "Nutmeg",
    ],
    howToUse: "Mix 1 tbsp with curd or aloe gel, apply to face and neck, let dry, then rinse.",
    images: [],
    variants: [
      { id: "sandalwood-10g", label: "Sandalwood", size: "10 g", price: 99, isTrial: true },
      { id: "sandalwood-20g", label: "Sandalwood", size: "20 g", price: 349, isTrial: false },
      { id: "sandalwood-30g", label: "Sandalwood", size: "30 g", price: 449, isTrial: false },
    ],
  },
  {
    slug: "body-ubtan",
    name: "Body Ubtan",
    category: "Cleansers",
    section: "Face Packs & Ubtans",
    bestSeller: false,
    rating: 4.7,
    reviews: 108,
    description: "Traditional body polish to cleanse gently and leave skin soft and radiant.",
    ingredients: ["Rose Petal Powder", "Orange Peel Powder", "Ayurvedic Herbal Blend"],
    howToUse: "Mix with water, rose water, or curd. Apply to damp skin, massage softly, and rinse.",
    images: [],
    variants: [
      { id: "rose-10g", label: "Rose", size: "10 g", price: 99, isTrial: true },
      { id: "rose-30g", label: "Rose", size: "30 g", price: 399, isTrial: false },
      { id: "orange-10g", label: "Orange", size: "10 g", price: 99, isTrial: true },
      { id: "orange-30g", label: "Orange", size: "30 g", price: 399, isTrial: false },
    ],
  },
  {
    slug: "nabhi-tel",
    name: "Nabhi Tel",
    category: "Serums",
    section: "Body & Face Oils",
    bestSeller: false,
    rating: 4.6,
    reviews: 82,
    description: "Night ritual belly-button oil crafted to support glow and acne-care routines.",
    ingredients: ["Coconut Rose Blend", "Mustard Neem Blend"],
    howToUse:
      "Apply 2-3 drops to belly button before bed. Massage clockwise, leave overnight, and clean in morning.",
    images: [],
    variants: [
      { id: "coconut-rose-20ml", label: "Coconut Rose", size: "20 ml", price: 349, isTrial: false },
      { id: "mustard-neem-20ml", label: "Mustard Neem", size: "20 ml", price: 349, isTrial: false },
    ],
  },
  {
    slug: "silver-aloe-glow-gel",
    name: "Silver Aloe Glow Gel",
    category: "Serums",
    section: "Gels",
    bestSeller: true,
    rating: 4.8,
    reviews: 175,
    description: "Cooling aloe gel infused with silver leaf for calm, balanced, luminous skin.",
    ingredients: ["Aloe Vera", "Miracle Plant Extract", "Silver Leaf", "Oregon Grape Extract", "Ylang-Ylang Essence Oil"],
    howToUse: "Massage pea-sized amount into skin in circular motions until absorbed. Use twice daily.",
    images: [],
    variants: [
      { id: "saffron-6g", label: "Saffron", size: "6 g", price: 149, isTrial: true },
      { id: "saffron-20g", label: "Saffron", size: "20 g", price: 349, isTrial: false },
      { id: "saffron-50g", label: "Saffron", size: "50 g", price: 749, isTrial: false },
    ],
  },
  {
    slug: "healing-oil",
    name: "Healing Oil",
    category: "Serums",
    section: "Body & Face Oils",
    bestSeller: false,
    rating: 4.7,
    reviews: 89,
    description: "Comforting camphor-based oil for targeted soothing massage.",
    ingredients: ["Camphor", "Herbal Carrier Oils"],
    howToUse: "Apply gently on desired area and massage with light circular strokes.",
    images: [],
    variants: [
      { id: "camphor-6ml", label: "Camphor", size: "6 ml", price: 99, isTrial: true },
      { id: "camphor-20ml", label: "Camphor", size: "20 ml", price: 249, isTrial: false },
    ],
  },
  {
    slug: "nail-growth-oil",
    name: "Nail Growth Oil",
    category: "Serums",
    section: "Body & Face Oils",
    bestSeller: false,
    rating: 4.6,
    reviews: 64,
    description: "Targeted nail-care oil to nourish cuticles and support healthy nail growth.",
    ingredients: ["Rose Extract", "Nourishing Oil Blend"],
    howToUse: "Apply a few drops on nails and cuticles daily and massage gently.",
    images: [],
    variants: [{ id: "rose-6ml", label: "Rose", size: "6 ml", price: 149, isTrial: true }],
  },
  {
    slug: "all-purpose-gel",
    name: "All Purpose Gel",
    category: "Serums",
    section: "Gels",
    bestSeller: false,
    rating: 4.7,
    reviews: 77,
    description: "Multi-use herbal gel for daily soothing care and lightweight hydration.",
    ingredients: ["Lemongrass", "Aloe Base", "Herbal Actives"],
    howToUse: "Apply evenly on skin as needed and massage until absorbed.",
    images: [],
    variants: [
      { id: "lemongrass-6g", label: "Lemongrass", size: "6 g", price: 149, isTrial: true },
      { id: "lemongrass-20g", label: "Lemongrass", size: "20 g", price: 349, isTrial: false },
      { id: "lemongrass-50g", label: "Lemongrass", size: "50 g", price: 749, isTrial: false },
    ],
  },
  {
    slug: "shuddhikaran",
    name: "Shuddhikaran",
    category: "Cleansers",
    section: "Wellness",
    bestSeller: false,
    rating: 4.6,
    reviews: 52,
    description: "Camphor-led wellness blend used for traditional purification routines.",
    ingredients: ["Camphor", "Salt and Herbal Blend"],
    howToUse: "Use in your preferred space-cleansing ritual as directed.",
    images: [],
    variants: [{ id: "camphor-30g", label: "Camphor", size: "30 g", price: 549, isTrial: false }],
  },
].map((product) => {
  const normalizedVariants = product.variants.map((variant) => ({ ...variant, image: variant.image || "" }));
  const largestVariant = normalizedVariants.reduce((best, current) => {
    if (!best) return current;
    return sizeToNumber(current.size) > sizeToNumber(best.size) ? current : best;
  }, null);
  const variantPrices = product.variants.map((variant) => Number(variant.price));
  const minPrice = Math.min(...variantPrices);
  const maxPrice = Math.max(...variantPrices);
  const calculatedMrp = maxPrice === minPrice ? Math.round(maxPrice * 1.18) : maxPrice;
  return {
    ...product,
    images: [],
    image: "",
    variants: normalizedVariants,
    defaultVariantId: largestVariant?.id || normalizedVariants[0]?.id,
    price: minPrice,
    mrp: calculatedMrp,
    skinType: "Suitable for all skin types",
    shelfLife: "12 months",
  };
});

let cachedProducts = null;

export const getProducts = () => {
  // Return cached products if available (fetched from backend)
  if (cachedProducts && cachedProducts.length > 0) {
    return cachedProducts;
  }
  return productCatalog;
};

export const saveProducts = async (nextProducts) => {
  if (typeof window === "undefined") return;
  cachedProducts = nextProducts;
  try {
    await fetch(`${API}/admin/products`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ products: nextProducts }),
    });
  } catch (err) {
    console.error("Failed to save products:", err);
  }
};

// Fast: update only one product (avoids sending 15MB payload for single variant change)
export const saveSingleProduct = async (slug, productData) => {
  if (typeof window === "undefined") return false;
  // Update in-memory cache
  if (cachedProducts) {
    cachedProducts = cachedProducts.map((p) => (p.slug === slug ? productData : p));
  }
  try {
    const res = await fetch(`${API}/admin/products/${slug}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ product: productData }),
    });
    return res.ok;
  } catch (err) {
    console.error("Failed to save product:", err);
    return false;
  }
};

export const fetchProducts = async () => {
  try {
    const response = await fetch(`${API}/products`);
    if (response.ok) {
      const data = await response.json();
      if (data.products !== undefined && data.products.length > 0) {
        const resolveImg = (img) => {
          if (!img) return "";
          if (img.startsWith("data:")) return img;          // base64 — use directly
          if (img.startsWith("/api/")) return `${BACKEND_URL}${img}`;  // URL path
          return img;
        };        const merged = data.products.map((fetched) => {
          const mainImage = resolveImg(fetched.image);
          const images = (fetched.images || []).map((img) => resolveImg(img)).filter(Boolean);
          const variants = (fetched.variants || []).map((v) => ({
            ...v,
            image: resolveImg(v.image),
          }));
          return { ...fetched, image: mainImage, images, variants };
        });
        cachedProducts = merged;
        return cachedProducts;
      }
    }
  } catch {
    // Fall back to catalog on network error
  }
  return productCatalog;
};

export const getProductsByCategory = (category) => getProducts().filter((product) => product.category === category);

export const getProductBySlug = (slug) => getProducts().find((product) => product.slug === slug);

export const getBestSellers = () => getProducts().filter((product) => product.bestSeller);

export const getTinyTreasureProducts = () =>
  getProducts().filter((product) => product.variants?.some((variant) => variant.isTrial));

export const getProductStartingPrice = (product) => {
  const prices = (product.variants || []).map((variant) => Number(variant.price));
  if (!prices.length) {
    return Number(product.price || 0);
  }
  return Math.min(...prices);
};
